import styled from "@emotion/styled"
import { colorContrastLow, spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import type { JSX } from "react"
import { Fragment } from "react"

type MenuSection = JSX.Element[]

export interface HoverableFlyoutMenuProps {
	menu: MenuSection[]
}

export const HoverableFlyoutMenu = ({ menu }: HoverableFlyoutMenuProps) => {
	return menu.map((section, i) => (
		<Section key={i}>
			{section.map((item, itemKey) => (
				<Fragment key={itemKey}>{item}</Fragment>
			))}
		</Section>
	))
}

const Section = styled.div`
	display: flex;
	flex-direction: column;
	padding: ${spacingStaticSm};
	gap: ${spacingStaticSm};

	&:not(:first-of-type) {
		border-top: 1px solid ${colorContrastLow};
	}
`
